import { IconPlus } from '@tabler/icons-react';
import { NSButton, NSSlideout } from 'bricks';
import React, { useState } from 'react';
import { IDealProject } from 'views/DocumentLibrary/types';
import UpsertProjectsModal from 'views/DealDashboard/Activity/UpsertProjectsModal';
import { useQuery } from '@tanstack/react-query';
import getCRMDealProjectsQueryOptions from 'views/DealDashboard/Activity/hooks/useGetCRMDealProjects';
import ProjectCard from './ProjectCard';

export interface AssociatedProjectSlideoutProps {
    organizationId: string;
    dealId: number;
    isOpen: boolean;
    toggle: () => void;
    associatedProjects: IDealProject[];
}

const AssociatedProjectSlideout: React.FC<AssociatedProjectSlideoutProps> = ({
    isOpen,
    toggle,
    associatedProjects,
    organizationId,
    dealId,
}) => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);

    const {
        data: crmAssociatedProjects,
        isLoading: isLoadingCRMAssociatedProjects,
    } = useQuery(getCRMDealProjectsQueryOptions(organizationId, dealId));

    return (
        <NSSlideout
            modalHeaderText="Associated Projects"
            size="xl"
            isOpen={isOpen}
            toggle={toggle}
            modalBodyClassName="p-3"
            customHeaderActions={(
                <NSButton
                    color="secondary"
                    className="mr-2 heap-deal-documents-assc-projects-add"
                    icon={IconPlus}
                    text="Add associated project"
                    callback={() => setIsAddModalOpen(true)}
                    data-testid="add-project-button"
                />
            )}
        >
            {
                associatedProjects && associatedProjects.length > 0 && associatedProjects.map(project => (
                    <ProjectCard
                        key={project.id}
                        subprojectId={project.id}
                        subprojectCorrelationId={project.correlationId}
                        projectName={project.subprojectName}
                        developmentName={project.developmentProject.projectName}
                    />
                ))
            }
            {isAddModalOpen && (
                <UpsertProjectsModal
                    isOpen={isAddModalOpen}
                    toggle={() => setIsAddModalOpen(false)}
                    organizationId={organizationId}
                    dealId={dealId}
                    existingAssociations={crmAssociatedProjects || []}
                    isLoadingExistingAssociations={isLoadingCRMAssociatedProjects}
                />
            )}
        </NSSlideout>
    );
};

export default AssociatedProjectSlideout;
